export type {
  ContentIntelligenceSummaryBucket as RegistryIntelligenceSummaryBucket,
  ContentIntelligenceSummaryResponse as RegistryIntelligenceSummaryResponse,
} from '@decantr/content/content-types';
export * from '@decantr/content/content-types';
